module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("41q8y"))).then(() => module.bundle.root('cvs7o'));